let serverFormsState = {};

const getNotUpdatedServerFormFields = (instanceToken, fields) => {
  const notUpdatedFields = {};
  if (!serverFormsState[instanceToken]) {
    return fields;
  }
  Object.keys(fields).forEach(key => {
    if (serverFormsState[instanceToken][key] !== fields[key].value) {
      notUpdatedFields[key] = fields[key];
    }
  });
  return notUpdatedFields;
};

const setServerFormState = ({ instanceToken, fields, values }) => {
  if (!serverFormsState[instanceToken]) {
    serverFormsState[instanceToken] = {};
  }
  if (fields) {
    Object.keys(fields).forEach(key => {
      serverFormsState[instanceToken][key] = fields[key].value;
    });
  }
  if (values) {
    Object.keys(values).forEach(key => {
      serverFormsState[instanceToken][key] = values[key];
    });
  }
};

const deleteServerFormState = instanceToken => {
  const newServerFormsState = {};
  Object.keys(serverFormsState)
    .filter(key => key !== instanceToken)
    .forEach(filteredKey => {
      newServerFormsState[filteredKey] = serverFormsState[filteredKey];
    });
  serverFormsState = {
    ...newServerFormsState
  };
};

export default {
  getNotUpdatedServerFormFields,
  setServerFormState,
  deleteServerFormState
};



// WEBPACK FOOTER //
// ./src/store/forms/utils/formsCache.js